import { render, staticRenderFns } from "./DepartmentsSearchAndNavigate.vue?vue&type=template&id=05a9fc58&scoped=true"
import script from "./DepartmentsSearchAndNavigate.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentsSearchAndNavigate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentsSearchAndNavigate.vue?vue&type=style&index=0&id=05a9fc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9fc58",
  null
  
)

export default component.exports